import { p as proxyCustomElement, H, h } from './p-Dm99HnvB.js';
import { d as defineCustomElement$2 } from './p-mXCWGNJJ.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.5.0
 */

const PageHeader = /*@__PURE__*/ proxyCustomElement(class PageHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Indicates whether the page header is inactive or not.
         * When set to true, the page header is visually inactive
         * @prop {boolean} inactive - Controls the inactive state of the page. Defaults to false.
         */
        this.inactive = false;
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        var _a, _b;
        const hasNavigationSlot = !!this.el.querySelector("[slot='navigation']");
        const hasMultiActions = ((_b = (_a = this.el.querySelector("[slot='actions']")) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length) > 1;
        return (h("header", { key: '82389bffc1bbc3e9978c53cbca351eca3dd5bc92', class: {
                "tds-page-header": true,
                "has-multi-actions": hasMultiActions,
                "has-nav": hasNavigationSlot,
                "tds-page-header--profile": this.profile,
                inactive: this.inactive,
            } }, h("div", { key: '7870ec81ace64946832bdb33545da5bb6e3cfd13', class: "tds-page-header__title-bar" }, h("div", { key: 'da1c34d5e8b74e586fc1bd85d2d883e3a1e792e3', class: "tds-page-header__primary" }, h("slot", { key: 'b10e67c9c5dfa52887dbf1aaa4827b789da0ccef' })), h("slot", { key: '6f577ac24aec9430b4137707dbbaa03b2f655331', name: "actions" })), hasNavigationSlot && (h("tds-page-header-nav", { key: '96453127aee56e2b296688e5eb3e933c28a451eb' }, h("slot", { key: '988d91ff9a823a8ef031e9d2b0a2db0853590aa9', name: "navigation" })))));
    }
    get el() { return this; }
}, [4, "tds-page-header", {
        "inactive": [4],
        "profile": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-page-header", "tds-page-header-nav"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-page-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PageHeader);
            }
            break;
        case "tds-page-header-nav":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-page-header.js.map
